import { styled } from "styled-components";

import { ImageBackground, SourceLabel } from "common/components";
import type { CustomKnowledge } from "domains/customContentAndSources/types";
import { StyledContent, StyledTitle, StyledType } from "domains/knowledgeFeed/components/shared";
import { KnowledgeDetailButton } from "domains/publication/components/KnowledgeDetailButton";
import type { Knowledge } from "entities/knowledge/types";

const StyledOuterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledRow = styled.div`
  display: flex;
  margin-right: 1rem;
`;

const StyledImage = styled(ImageBackground)`
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  border-radius: 5px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledKnowledgeDetailButton = styled(KnowledgeDetailButton)`
  flex: 0;
`;

type PublicationCardHeadProps = { knowledge: Knowledge | CustomKnowledge; link: string };

export const PublicationCardHead = ({ knowledge, link }: PublicationCardHeadProps) => {
  const { title, source, time, knowledgeType } = knowledge;
  return (
    <StyledOuterRow title={title}>
      <StyledRow>
        {source.images?.thumbnail && <StyledImage src={source.images.thumbnail} />}
        <StyledContent>
          <StyledType>{knowledgeType}</StyledType>
          <StyledTitle>{title}</StyledTitle>
          <SourceLabel date={time} hideImage source={source} type="small" />
        </StyledContent>
      </StyledRow>
      <StyledKnowledgeDetailButton link={link} title={knowledge.title} />
    </StyledOuterRow>
  );
};
